<template>
  <div>
    <el-table
            :data="dataList"
            border
            stripe
            ref="dataTable"
            v-loading="dataListLoading"
            style="width: 100%;margin:12px 0px"
            @sort-change="sortChange"
            :header-cell-style="this.$globalGrayTableHeaderStyle"

    >
      <el-table-column
              type="index"
              label="序号"
              width="50"
              :index="getRowsIndex"
              align="center">
      </el-table-column>
      <el-table-column
              prop="bidOpeningStatus"
              show-overflow-tooltip
              label="开标状态"
              align="center">
        <template slot-scope="scope">
          <span>{{formattOpenStatus(scope.row.bidOpeningStatus)}}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="evalStatus"
              show-overflow-tooltip
              label="评标状态"
              align="center">
        <template slot-scope="scope">
          <span>{{formattEvalStatus(scope.row.bidOpeningStatus)}}</span>
        </template>
      </el-table-column>
      <el-table-column
              prop="bidSectionCode"
              show-overflow-tooltip
              label="标段编号"
              sortable
              align="center"
      >
      </el-table-column>
      <el-table-column
              prop="bidName"
              show-overflow-tooltip
              label="标段名称"
              align="center"
      >
      </el-table-column>
      <el-table-column
              prop="bidopenStime"
              label="开标时间"
              sortable
              :show-overflow-tooltip="true"
              align="center"
      >
      </el-table-column>
      <el-table-column
              label="开标室"
              align="center"
      >
        <template slot-scope="scope">
          <span><span :key="index" v-for="(it,index) in scope.row.bidOpenRooms">{{it.filedName}}</span></span>
        </template>
      </el-table-column>
      <el-table-column
              prop="fieldName"
              show-overflow-tooltip
              label="评标室"
              align="center"
      >
        <template slot-scope="scope">
          <span><span :key="index" v-for="(it,index) in scope.row.evalRooms">{{it.filedName}}</span></span>
        </template>
      </el-table-column>
      <el-table-column
              prop="superviseDeptName"
              show-overflow-tooltip
              label="监督部门"
              align="center"
      >
      </el-table-column>
      <el-table-column
              fixed="right"
              align="center"
              width="250"
              label="操作">
        <template slot-scope="scope">
<!--          <el-button type="text" @click="$emit('openBidWitnessDetail',scope.row,'openView')">进入开标监管</el-button>-->
<!--          <el-button type="text" @click="$emit('openBidWitnessDetail',scope.row,'evalView')">进入评标监管</el-button>-->
          <el-button size="mini"
                     v-if="([1,2].indexOf(scope.row.bidOpeningStatus) > -1 &&  scope.row.bidOpeningHistory != 2) || ([3,4,5].indexOf(scope.row.bidOpeningStatus) > -1 && scope.row.bidOpeningHistory == 1)"
                     :disabled="formatDisable(scope.row,'open')"
                     type="primary" @click="$emit('openBidWitnessDetail',scope.row,'openEdit')">进入开标监管</el-button>
          <el-button size="mini" plain v-if="[3,4,5].indexOf(scope.row.bidOpeningStatus) > -1 && scope.row.bidOpeningHistory == 0" disabled>进入开标监管</el-button>
          <el-button size="mini" plain v-if="scope.row.bidOpeningHistory == 2" @click="$emit('openBidWitnessDetail',scope.row,'openView')">开标监督记录</el-button>

          <el-button size="mini"
                     v-if="([1,2,3].indexOf(scope.row.evalStatus) > -1 &&  scope.row.evalHistory != 2) || ([4,5].indexOf(scope.row.evalStatus) > -1 && scope.row.evalHistory == 1)"
                     :disabled="formatDisable(scope.row,'eval')"
                     type="primary" @click="$emit('openBidWitnessDetail',scope.row,'evalEdit')">进入评标监管</el-button>
          <el-button size="mini" plain v-if="[4,5].indexOf(scope.row.evalStatus) > -1 && scope.row.evalHistory == 0" disabled>进入评标监管</el-button>
          <el-button size="mini" plain v-if="scope.row.evalHistory == 2" @click="$emit('openBidWitnessDetail',scope.row,'evalView')">评标监督记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :total="totalPage"
            layout="total, prev, pager, next, jumper"/>
  </div>


</template>
<script>
  import {queryOpenEvalList} from '@/server/bidOpenEvalWitness';
export default {
  components: {
  },
  data() {
    return {
      dataListLoading: false,
      dataList: [],
      pageIndex: 1,
      paramsData:{
        filter:{

        }
      },
      sortParams:{
        prop:'',
        order:''
      },
      pageSize: 8,
      totalPage: 0,
    };
  },
  created() {
    // this.getDataList();
  },
  activated() {

  },
  mounted() {
    const that = this;
    let resizeTag = true
    window.onresize = () => {
      if (resizeTag) { //防抖动
        that.ifmove();
        resizeTag = false
        setTimeout(() => {
          resizeTag = true
        }, 1000)
      }
    }
  },
  methods: {
    sortChange(column, prop, order){
      this.sortParams.prop = prop || column.prop;
      this.sortParams.order = order || column.order;
      this.getDataList();
    },
    // 判断目标日期跟今天差多少天 0 是今天 正数是过去的天数，负数是未来的天数
    judgeTime(data){
      var d1 = new Date(data); // 目标日期
      var dd = new Date(); // 当前日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1;
      var d = dd.getDate();
      var d2 = new Date(y + '/' + m + '/' + d);
      var iday = parseInt(d2 - d1) / 1000 / 60 / 60 / 24;
      return iday;
    },
    formatDisable(data,type){
      let number = this.judgeTime(data.bidOpenTime);
      if(number < 0){ // 今天之后
        return false
      }
      if(type == 'open' && data.bidOpeningStatus == 1){
        return true
      }
      if(type == 'eval' && data.evalStatus == 1){
        return true
      }
      return false
    },
    formattEvalStatus(evalStatus){
      switch(evalStatus){
        case 1 : return '等待评标'; break;
        case 2 : return '评标准备中'; break;
        case 3 : return '评标中'; break;
        case 4 : return '评标流标'; break;
        case 5 : return '评标结束'; break;
      }
    },
    formattOpenStatus(openStatus){
      switch(openStatus){
        case 1 : return '等待开标'; break;
        case 2 : return '开标中'; break;
        case 3 : return '取消开标'; break;
        case 4 : return '已流标'; break;
        case 5 : return '开标结束'; break;
      }
    },
    getRowsIndex(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    // 获取数据列表
    getDataList(params) {
      this.paramsData = params || this.paramsData;
      this.dataListLoading = false;
      queryOpenEvalList({
          page:params?1:this.pageIndex,
          rows:this.pageSize,
          'orderBy':(this.sortParams.prop && this.sortParams.order)?('a.'+ this.sortParams.prop + (this.sortParams.order == "ascending"?' asc':' desc')):"",
          filter:this.paramsData.filter,
          searchKey:'',
        }).then((res)=>{
            this.dataList = res.data.rows || [];
            this.$refs.dataTable.doLayout();
            this.totalPage = res.data.total || 0
        })
      },
    // 进入开标监管
    showOpenDetail(row){
       this.$router.push({
        name:'openBidAndEstimateWitness_detail',
        // query:{
        //   id:item.bidCode,
        // }
      })
    },
    // 进入评标监督
    showBidDetail(row){
       this.$router.push({
        name:'openBidAndEstimateWitness_detail',
        // query:{
        //   id:item.bidCode,
        // }
      })
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
